import { render, staticRenderFns } from "./KeySixteen.vue?vue&type=template&id=132956e8&scoped=true&"
import script from "./KeySixteen.vue?vue&type=script&lang=js&"
export * from "./KeySixteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132956e8",
  null
  
)

export default component.exports